import { render, staticRenderFns } from "./apiDocument.vue?vue&type=template&id=4923aeba&scoped=true&"
import script from "./apiDocument.vue?vue&type=script&lang=js&"
export * from "./apiDocument.vue?vue&type=script&lang=js&"
import style0 from "./apiDocument.vue?vue&type=style&index=0&id=4923aeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923aeba",
  null
  
)

export default component.exports